import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-inventario-edit',
  templateUrl: './inventario-edit.component.html',
  standalone: false
})
export class InventarioEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/inventario`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Inventário', link: '/inventario' }, { label: 'Edição Inventário' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'inventario',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('inventario').subscribe(data => {
        this.fields = data;
    });
  }

}
